/**
 * VENDOR MODULES
 */
import React from 'react';
import i18n  from "i18n";

import GridOdd from 'shared/components/outcomes/grids/GridOdd';
import { vsOutcomeTypeKey } from 'lib/virtualSportsI18n';
import { baseballFinalOutcomeOutcomeTypeId, baseballFinalOutcomePitchesOutcomeTypeId, baseballFinalOutcomeUnderOverOutcomeTypeId } from 'lib/virtualSportsOutcomeIds';

/**
 * Renders the lists of combinations for final outcomes and over under
 *
 * @class  FinalAndOverUnders (name)
 * @param  {<type>}   props The properties
 * @return {boolean}  { description_of_the_return_value }
 */
function FinalAndOverUnders(props) {
  const {
    outcomes,
  } = props

  /**
   * the final outcomes in order
   *
   * @type {Array}
   */
  const final_outcome_order = [
    'STRIKEOUT',
    'WALK',
    'FLYOUT',
    'GROUNDOUT',
    'HIT',
    'HOMERUN',
    'HITBYPITCH'
  ];

  const StrikeoutPitchesLabel = () => {
    return (
      <>
        <div className="grid grid-cols-4 gap-2 items-center py-1 bg-muted/30 p-2">
          <div className="text-center"><span></span></div>
          <div className="text-center"><span className="text-xs text-muted-foreground">3/4</span></div>
          <div className="text-center"><span className="text-xs text-muted-foreground">5</span></div>
          <div className="text-center"><span className="text-xs text-muted-foreground">6/7</span></div>
        </div>
      </>
    );
  }

  const WalkPitchesLabel = () => {
    return (
      <>
        <div className="grid grid-cols-4 gap-2 items-center py-1 bg-muted/30 p-2">
          <div className="text-center"><span></span></div>
          <div className="text-center"><span className="text-xs text-muted-foreground">4/5</span></div>
          <div className="text-center"><span></span></div>
          <div className="text-center"><span className="text-xs text-muted-foreground">6/7</span></div>
        </div>
      </>
    );
  }

  const RestsPitchesLabel = () => {
    return (
      <>
        <div className="grid grid-cols-4 gap-2 items-center py-1 bg-muted/30 p-2">
          <div className="text-center"><span></span></div>
          <div className="text-center"><span className="text-xs text-muted-foreground">1/2/3</span></div>
          <div className="text-center"><span className="text-xs text-muted-foreground">4</span></div>
          <div className="text-center"><span className="text-xs text-muted-foreground">5/6/7</span></div>
        </div>
      </>
    );
  }

  /**
   * This outcomes goes ni the middle column
   */
  const final_and_pitches = Object.values(outcomes)
    .filter(x => parseInt(x.market_type_id) === 4003)

  const final_and_overunder = Object.values(outcomes)
    .filter(x => parseInt(x.market_type_id) === 4004)
    .slice()
    .sort((a, b) => Number(a.outcome_type_id) - Number(b.outcome_type_id));

  const final_and_overunder_list = final_outcome_order.reduce((lists, outcome_name, outcomeIndex) => {
    const finalOutcome = outcome_name;
    const over_under_names = ['UNDER', 'pitches', 'OVER'];
    const combos = over_under_names.map(market => {
      let pitch_number = null;

      /**
       * Special condition to achieve middle column data
       */
      if (market == 'pitches') {
        if (finalOutcome.toLowerCase() == 'strikeout') {
          pitch_number = 5
        }
        if (!['strikeout', 'walk'].includes(finalOutcome.toLowerCase())) {
          pitch_number = 4
        }
        let match = {};
        try {
          const otid = baseballFinalOutcomePitchesOutcomeTypeId({ finalOutcome, pitchN: pitch_number });
          match = final_and_pitches.find((x) => String(x.outcome_type_id) === otid) || {};
        } catch (e) {
          match = {};
        }
        return (
          <GridOdd
            key={market}
            {...{
              ...match,
              class_names: ['grid-odd-baseball', 'bg-background/80', 'w-full', 'p-2', 'min-h-[44px]'],
              market_type_group_id: 403
            }}
          />
        );
      }

      const side = market === 'UNDER' ? 'UNDER' : 'OVER';
      const outcomeTypeId = baseballFinalOutcomeUnderOverOutcomeTypeId({ finalOutcome, side });
      const match = final_and_overunder.find((x) => String(x.outcome_type_id) === outcomeTypeId) || {};
      return (
        <GridOdd
          key={market}
          {...{
            ...match,
            class_names: ['grid-odd-baseball', 'bg-background/80', 'w-full', 'p-2', 'min-h-[44px]'],
            market_type_group_id: 404
          }}
        />
      );
    });
    lists = lists.concat([
      <React.Fragment key={lists.length}>
        {finalOutcome.toLowerCase() == 'strikeout' && <StrikeoutPitchesLabel/>}
        {finalOutcome.toLowerCase() == 'walk' && <WalkPitchesLabel/>}
        {finalOutcome.toLowerCase() == 'flyout' && <RestsPitchesLabel/>}
        <div className="grid grid-cols-4 gap-2 items-center py-2 border-b border-border px-2">
          <div className="flex items-center justify-center">
            <span className="text-xs text-foreground">
              {i18n.t(vsOutcomeTypeKey(baseballFinalOutcomeOutcomeTypeId(finalOutcome), false))}
            </span>
          </div>
          {combos}
        </div>
      </React.Fragment>
    ]);
    return lists;
  }, []);

  /**
   * NOTE:
   * - This needs to be arranged carefully based from the virtual TV concept
   */
  return (
    <>
      {final_and_overunder_list}
    </>
  );
}

export default FinalAndOverUnders;

